import { appConfiguration } from "../configuration";

export const DEFAULT_URL = "http://localhost:3000";

export default function getOrigin() {
  return appConfiguration().url ?? DEFAULT_URL;
}
